import { PopUpContextProvider } from "./providers/PopUpContext";
import { ScrollContextProvider } from "./providers/ScrollContext";
import { LanguageContextProvider } from "./providers/LanguageContext";

const GeneralState = ({ children }) => {
	return (
		<PopUpContextProvider>
			<ScrollContextProvider>
				<LanguageContextProvider>{children}</LanguageContextProvider>
			</ScrollContextProvider>
		</PopUpContextProvider>
	);
};

export default GeneralState;
